import React from "react";
import { motion } from "framer-motion";

const perLocationRows = [
  {
    name: "Per-location monthly rate",
    detail:
      "Standard all-in per-location monthly rate brought down from $2,800 / location / month to $1,998 / location / month for all 5 Abraham Dental locations.",
    strike: "$2,800",
    discounted: "$1,998",
    unit: "/ location / month",
    badge: "Discounted",
  },
  {
    name: "Onboarding Consulting Package",
    detail:
      "Standard one-time per-location implementation & onboarding consulting package. Waived for all 5 Abraham Dental locations.",
    strike: "$1,800",
    discounted: "$0",
    unit: "per location, one-time",
    badge: "Waived",
  },
  {
    name: "SOTA Cloud Imaging",
    detail:
      "Standard $199 / location / month subsidized to $159 / location / month for Abraham Dental, plus first 3 months free for each of the 5 locations.",
    strike: "$199",
    discounted: "$159",
    unit: "/ location / month",
    badge: "+ 3 months free",
  },
  {
    name: "SOTA image conversion fee",
    detail:
      "Standard $995 one-time historical image conversion fee discounted to $500 through our partnership with SOTA.",
    strike: "$995",
    discounted: "$500",
    unit: "per location, one-time",
    badge: "Discounted",
  },
  {
    name: "SOTA onboarding fee",
    detail:
      "Standard $495 one-time SOTA Imaging onboarding fee waived through our partnership.",
    strike: "$495",
    discounted: "$0",
    unit: "per location, one-time",
    badge: "Waived",
  },
];

const AshaAbrahamConcessionsSlide = () => {
  return (
    <div className="h-full w-full bg-[#f8fafc] flex items-center justify-center p-6 xl:p-10 relative overflow-hidden font-sans">
      {/* Ambient gradient blurs */}
      <div
        className="absolute top-[-200px] right-[-100px] w-[700px] h-[700px] rounded-full blur-[120px] opacity-25 pointer-events-none"
        style={{ background: "linear-gradient(135deg, #93c5fd 0%, #c4b5fd 50%, #fbcfe8 100%)" }}
      />
      <div
        className="absolute bottom-[-200px] left-[-100px] w-[600px] h-[600px] rounded-full blur-[120px] opacity-20 pointer-events-none"
        style={{ background: "linear-gradient(135deg, #a5f3fc 0%, #93c5fd 50%, #c4b5fd 100%)" }}
      />
      <div className="absolute inset-0 bg-[radial-gradient(#cbd5e1_0.8px,transparent_0.8px)] [background-size:28px_28px] opacity-40 pointer-events-none" />

      <div className="w-full max-w-[1100px] z-10 relative">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-7"
        >
          <h2 className="text-3xl lg:text-[40px] font-bold text-slate-900 tracking-tight leading-tight">
            Special exceptions &amp;{" "}
            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              discounts.
            </span>
          </h2>
          <p className="text-[14px] text-slate-600 mt-2 max-w-[760px]">
            Contingent on signing a 6-month agreement covering all 5 Abraham
            Dental locations.
          </p>
        </motion.div>

        {/* Per-location concessions table */}
        <motion.table
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="w-full"
        >
          <thead>
            <tr className="border-t border-b border-slate-200">
              <th className="text-left py-3 pr-8 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500">
                Item
              </th>
              <th className="text-right py-3 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500 w-[280px]">
                Price per location
              </th>
            </tr>
          </thead>
          <tbody>
            {perLocationRows.map((row) => (
              <tr key={row.name} className="border-b border-slate-200 align-top">
                <td className="py-4 pr-8">
                  <div className="text-[15px] font-semibold text-slate-900 leading-snug">
                    {row.name}
                  </div>
                  <div className="text-[12.5px] text-slate-500 leading-relaxed mt-1 max-w-[720px]">
                    {row.detail}
                  </div>
                </td>
                <td className="py-4 text-right whitespace-nowrap">
                  <div className="flex items-baseline justify-end gap-2 leading-none">
                    <span className="text-[15px] font-medium text-slate-400 line-through">
                      {row.strike}
                    </span>
                    <span className="text-[22px] font-bold text-slate-900 tracking-tight">
                      {row.discounted}
                    </span>
                  </div>
                  <div className="text-[12px] text-slate-500 mt-1.5">
                    {row.unit}
                  </div>
                  {row.badge && (
                    <div className="text-[11px] font-bold uppercase tracking-[0.14em] text-emerald-700 mt-1.5">
                      → {row.badge}
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </motion.table>
      </div>
    </div>
  );
};

export default AshaAbrahamConcessionsSlide;
